import { Dialog, DialogActions, DialogContent } from '@mui/material'
import axios from 'axios'
import { useContext, useEffect, useRef, useState } from 'react'
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { APP_CONSTANTS, giftCardRedeemImageId } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getProfileDetails } from 'src/consumer/helpers/profilePageHelper'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { apiURL, commonHeadersWeb, mediaURL } from 'src/consumer/services'
import { useScreenSize } from 'src/customHooks/customHooks'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  GiftCardRedeemContent,
  GiftCardRedeemHeader,
  GiftCardRedeemText,
  GiftRedeemWrapper,
  StyledErrorButton,
  StyledGiftRedeemImg,
} from './GiftCardReedemStyles'
import RedeemScreen from './components/RedeemScreen'
import SwishClubFaqs from './components/SwishClubFaqs'
import { SuccessProceedToAppDialogPaper } from './components/styledComponents'
import NextStepsTabbedVideoComponent from './components/NextStepsTabbedVideoComponent'
import NextStepsVideoComponent from './components/NextStepsVideoComponent'

const GiftCardRedeem = ({
  heading,
  subHeading,
  inputPlaceholder,
  seoTitle,
  seoDescription,
  imageLink,
  supportEmail,
  addItemsToSessionStorage,
  benefitsActivatedLine,
  showStepsToRedeemVideo = false,
  stepsToRedeemVideoText,
  stepsToRedeemVideoLink,
  showFaqs,
  blockRedemptionIfPremium,
}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const faqRef = useRef(null)

  const [giftCardValue, setGiftCardValue] = useState(
    (urlParams?.has('code') && urlParams.get('code')) ||
      sessionStorage.getItem('lastSetGiftCardId') ||
      '',
  )
  const [redeemState, setRedeemState] = useState('redeem')
  const [sendRequest, setSendRequest] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const { profileData } = useContext(ProfileContext)
  const { name } = getProfileDetails(profileData)
  const [openAppInfoPopupOpen, setOpenAppInfoPopupOpen] = useState(false)

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('signup')

  useEffect(() => {
    const token = localStorage.getItem('token')
    sessionStorage.setItem('lastSetGiftCardId', giftCardValue)
    if (sendRequest) {
      if (token) {
        setSubmitLoading(true)
        axios({
          method: 'put',
          url: `${apiURL}/api/secure/purchase/packages?giftCode=${giftCardValue}`,
          headers: {
            Authorization: `Bearer ${token}`,
            ...commonHeadersWeb,
            'ef-user-country-code': localStorage.getItem('countryCode'),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        })
          .then((res) => {
            setRedeemState('success')
          })
          .catch((error) => {
            setRedeemState('failure')
          })
          .finally(() => {
            setGiftCardValue('')
            setDisabled(false)
            setSubmitLoading(false)
            setSendRequest(false)
          })
      } else {
        setShowClubbedAuthModal(true)
        setSendRequest(false)
      }
    }
  }, [sendRequest])

  useEffect(() => {
    if (addItemsToSessionStorage) {
      Object.entries(addItemsToSessionStorage).forEach(([key, value]) => {
        sessionStorage.setItem(key, value)
      })
    }
  }, [addItemsToSessionStorage])

  const renderSuccessScreen = () => {
    return (
      <>
        <GiftCardRedeemHeader color="#94FF83">{'Successfully Redeemed !'}</GiftCardRedeemHeader>
        <GiftCardRedeemText>
          <div>
            Dear {profileData?.name},{' '}
            {benefitsActivatedLine ||
              'Your Giftcard benefits have been successfully credited. These will be activated soon.'}
          </div>
        </GiftCardRedeemText>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <GiftCardRedeemText style={{ marginBottom: '16px' }}>
            <div>Your next step is</div>
          </GiftCardRedeemText>
          {
            <button
              style={{
                maxWidth: '300px',
                marginBottom: '8px',
                background: '#ffffff',
                borderRadius: '32px',
                padding: '16px',
                fontWeight: 500,
                fontSize: '18px',
                zIndex: 1000,
                color: '#000000',
                textAlign: 'center',
                width: '100%',
              }}
              onClick={() => setOpenAppInfoPopupOpen(true)}
            >
              {'Proceed to the App'}
            </button>
          }
          {/* {redeemState === 'success' && width > 768 && (
            <div style={{ padding: '16px', background: '#fff', borderRadius: '8px' }}>
              <AppDownloadComponent qrCodeVariant={true} />
            </div>
          )} */}
          <a href="/" style={{ color: '#fff', textDecoration: 'underlineF' }}>
            {'Continue on the Web'}
          </a>
        </div>

        {openAppInfoPopupOpen && (
          <Dialog open={openAppInfoPopupOpen} PaperComponent={SuccessProceedToAppDialogPaper}>
            {/* <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            > */}
            <DialogContent>
              <div style={{ margin: '0 0 24px' }}>
                <div>On the app, login (do not signup) with the following credentials:</div>
                <div>
                  Login type: <strong>{findLoginType(profileData)}</strong>
                </div>
                <div>
                  Login Id: <strong>{profileData?.userName}</strong>
                </div>
              </div>
              <NextStepsVideoComponent
                buttonText="Video Walkthrough"
                buttonTextColor="#000"
                videoLink={APP_CONSTANTS.SWISH_CLUB_CODE_REDEEM_VIDEO_LINK}
              />
            </DialogContent>
            <DialogActions
              sx={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}
            >
              <a
                href="https://aumhum.page.link/app"
                style={{
                  background: '#000',
                  color: '#fff',
                  borderRadius: '32px',
                  padding: '12px',
                  width: '200px',
                  textDecoration: 'none',
                  textAlign: 'center',
                  marginBottom: '12px',
                }}
              >
                Proceed to the App
              </a>
              <div
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() => setOpenAppInfoPopupOpen(false)}
              >
                Cancel
              </div>
            </DialogActions>
            {/* </div> */}
          </Dialog>
        )}

        <GiftCardRedeemText style={{ marginBottom: '16px', marginTop: '48px' }}>
          <div>If you face any issues, please write to us at </div>
          <div>
            <a
              href={`mailto:${supportEmail || APP_CONSTANTS.SUPPORT_EMAIL}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#fff' }}
            >
              {supportEmail || APP_CONSTANTS.SUPPORT_EMAIL}
            </a>
          </div>
        </GiftCardRedeemText>

        {showStepsToRedeemVideo && (
          <NextStepsVideoComponent
            buttonText={stepsToRedeemVideoText}
            videoLink={stepsToRedeemVideoLink}
          />
        )}

        {showFaqs && (
          <h5
            className="m-0"
            style={{
              textDecoration: 'underline',
              textAlign: 'center',
              color: '#d2d2d2',
              fontSize: '16px',
              cursor: 'pointer',
            }}
            onClick={() => {
              faqRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }}
          >
            Have Questions?
          </h5>
        )}
      </>
    )
  }

  const renderFailureScreen = () => {
    return (
      <>
        <GiftCardRedeemHeader color="#FF8383">
          {'Oops ! Your Entered the Wrong Code'}
        </GiftCardRedeemHeader>
        <GiftCardRedeemText>
          {'The code you entered was wrong. Try again with the code.'}
        </GiftCardRedeemText>
        <StyledErrorButton onClick={() => setRedeemState('redeem')}>
          {'Try again'}
        </StyledErrorButton>
      </>
    )
  }

  return (
    <>
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />
      <SEOComponent
        title={seoTitle || 'Redeem your AUMHUM gift card'}
        description={seoDescription || 'Redeem your AUMHUM gift card to unlock benefits.'}
        image={getImageLink(giftCardRedeemImageId)}
        keywordsArr={['Gift Card', 'Health Support', 'gift']}
      />
      <GiftRedeemWrapper>
        <GiftCardRedeemContent>
          {redeemState === 'redeem' && (
            <RedeemScreen
              heading={heading}
              subHeading={subHeading}
              inputPlaceholder={inputPlaceholder}
              imageLink={imageLink}
              name={name}
              giftCardValue={giftCardValue}
              setGiftCardValue={setGiftCardValue}
              setSendRequest={setSendRequest}
              disabled={disabled}
              showStepsToRedeemVideo={showStepsToRedeemVideo}
              stepsToRedeemVideoText={stepsToRedeemVideoText}
              stepsToRedeemVideoLink={stepsToRedeemVideoLink}
              submitLoading={submitLoading}
              setSubmitLoading={setSubmitLoading}
              showFaqs={showFaqs}
              haveQuestionsOnClickFunc={() => {
                faqRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }}
              blockRedemptionIfPremium={blockRedemptionIfPremium}
              openAuthModalFunc={() => setShowClubbedAuthModal(true)}
            />
          )}
          {redeemState === 'success' && renderSuccessScreen()}
          {redeemState === 'failure' && renderFailureScreen()}
          <StyledGiftRedeemImg alt="" src={`${mediaURL}${giftCardRedeemImageId}`} />
        </GiftCardRedeemContent>
      </GiftRedeemWrapper>
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal !== 'signup'}
        preferredLoginInputType={'email'}
        beforeReloadFunction={() => sessionStorage.setItem('triggerSubmitOnLoad', true)}
      />{' '}
      {showFaqs && (
        <div
          ref={faqRef}
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <SwishClubFaqs />
        </div>
      )}
      <PublicAppFooter />
    </>
  )
}

export default GiftCardRedeem

function findLoginType(profileData) {
  const socialGoogle = profileData?.socialConnections?.find((item) => item?.providerId === 'google')
  if (socialGoogle) {
    return 'Google Sign In'
  }
  const socialApple = profileData?.socialConnections?.find((item) => item?.providerId === 'apple')
  if (socialApple) {
    return 'Apple Sign In'
  }
  if (isValidEmail(profileData?.userName)) {
    return 'Email'
  }
  if (isValidMobileNumberTemp(profileData?.phoneNumber)) {
    return 'Mobile Sign In'
  }
  return ''
}

function isValidMobileNumberTemp(number) {
  // Check if the number consists of only digits and optionally starts with '+'
  const mobileRegex = /^[+]?[0-9]+$/
  return mobileRegex.test(number)
}
